import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import BlogDescription from "../components/description/BlogDescription";
import RelatedBlogList from "../components/list/RelatedBlogList";
import Loading from "../components/ui/Loading";
import { fetchBlog } from "../features/blog/blogSlice";

export default function Blog() {
    const { blog, isLoading, isError, error } = useSelector((state) => state.blog);
    const dispatch = useDispatch();
    const { blogId } = useParams();

    useEffect(() => {
        dispatch(fetchBlog(blogId));
    }, [dispatch, blogId]);


    // decide what to render
    let content = null;
    if (isLoading) content = <Loading />;

    if (!isLoading && isError)
        content = <div className="col-span-12">{error}</div>;

    if (!isLoading && !isError && !blog?.id) {
        content = <div className="col-span-12">No blog found!</div>;
    }

    if (!isLoading && !isError && blog?.id) {
        content = (
            <>
                <BlogDescription blog={blog} />
                <aside>
                    <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">Related Posts</h4>
                    <div className="space-y-4 related-post-container">
                        <RelatedBlogList currentBlogId={blog.id} tags={blog.tags} />
                    </div>
                </aside>
            </>
        );
    }

    return (
        <>
            <div className="container mt-8">
                <Link to="/" className="inline-block text-gray-600 home-btn" id="lws-goHome"><i
                    className="mr-2 fa-solid fa-house"></i>Go Home</Link>
            </div>
            <section className="post-page-container">
                {content}
            </section>
        </>
    );
}
